module.exports = __webpack_public_path__ + "static/media/md-arrow-dropright-circle.0321b3c6.svg";